import { ArrowUp } from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling 400px
      setShow(window.scrollY > 400);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Button
      variant="default"
      size="icon"
      onClick={scrollToTop}
      className={cn(
        "fixed bottom-8 right-8 z-50 rounded-full shadow-2xl transition-all duration-500 bg-accent text-accent-foreground hover:bg-accent/90 hover:scale-110 active:scale-95 border border-white/10",
        show ? "translate-y-0 opacity-100" : "translate-y-20 opacity-0 pointer-events-none",
      )}
      aria-label="Kembali ke atas"
    >
      <ArrowUp size={20} className="stroke-[3px]" />
    </Button>
  );
}
